import React from "react";
import { FOOTER } from "@/constants/testIds";
import { LOGO_URL } from "@/content/veguk";

export const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.root}
      className="bg-[#2C352D] text-[#D1C9B9] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-[#4A5D4E]/40">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={LOGO_URL}
                alt="VegUK logo"
                className="h-14 w-14 rounded-full bg-[#F9F6F0] p-1 object-contain"
              />
              <div>
                <div className="font-serif-display text-2xl text-[#F9F6F0]">VegUK</div>
                <div className="text-xs uppercase tracking-[0.22em] text-[#A7C2AE]">
                  Vegetarian Food Definition
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm leading-relaxed max-w-md">
              VegUK is a voluntary project to define and promote the recognised
              vegetarian types in the United Kingdom — for institutions, communities and
              individuals alike.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-[#A7C2AE] mb-4">
              Project management
            </div>
            <p className="text-sm leading-relaxed">
              The Raghuvanshi Association, South London in association with the Hindu
              Unity Group, South London.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.22em] text-[#A7C2AE] mb-4">
              Sponsor
            </div>
            <p className="text-sm">A J Consultants</p>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.22em] text-[#A7C2AE] mb-4">
              Contact
            </div>
            <a
              href="mailto:Info@VegetarianUK.org"
              className="text-sm hover:text-[#F9F6F0] transition-colors"
            >
              Info@VegetarianUK.org
            </a>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#A7C2AE]">
          <span>© {new Date().getFullYear()} VegUK. A voluntary project.</span>
          <span>
            Aligned with the Food Standards Agency UK, the Vegetarian Society and the
            Vegan Society.
          </span>
        </div>
      </div>
    </footer>
  );
};
